export const QUIZ_SECTION_ID = 'quiz-section';
